module.exports = __webpack_public_path__ + "img/3.1a60ee9e.png";